import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { AppCustomUrlSchemeLauncher } from 'src/components/organisms/AppCustomUrlSchemeLauncher'
import { envVars } from 'src/utils/env'

type Props = {}

export const LinkRedirect: React.FC<Props> = () => {
  const router = useRouter()
  const [redirectUrl, setRedirectUrl] = useState<string | undefined>(undefined)

  useEffect(() => {
    const url = router.query.url

    // 実際のリダイレクト
    if (typeof url == 'string') {
      setRedirectUrl(url)
    }
  }, [router.query.url])

  return (
    <>
      {redirectUrl && (
        <AppCustomUrlSchemeLauncher
          customScheme={`${envVars.appCustomUrlScheme}tsunagu?url=${redirectUrl}`}
          fallbackUrl={redirectUrl}
        />
      )}
    </>
  )
}
